var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('SisdaiNavegacionGobMx'),_c(_setup.NavegacionPrincipalBase),_c('SisdaiMenuAccesibilidad',{attrs:{"objetoStore":_setup.store}}),_c('router-view'),_c('SisdaiBotonFlotante',{attrs:{"enlaces":[
      {
        clasesCss: 'sisdai',
        contenido: 'Ir a Sisdai',
        enlace: 'https://sisdai.conahcyt.mx/',
      },
      {
        clasesCss: 'gema',
        contenido: 'Ir a GEMA',
        enlace: 'https://gema.conahcyt.mx/',
      },
    ]}}),_c('SisdaiInfoDeDespliegue',{attrs:{"versionProyecto":_setup.infoDespliegue.version_proyecto,"entornoProyecto":_setup.infoDespliegue.entorno_proyecto,"actualizacionProyecto":_setup.infoDespliegue.actualizacion_proyecto}}),_c('SisdaiPiePaginaConahcyt'),_c('SisdaiPiePaginaGobMx')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }